import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { ReactComponent as FacebookIcon } from 'assets/images/facebook.svg';
import { ReactComponent as TwitterIcon } from 'assets/images/twitter.svg';
import { ReactComponent as CopyLinkIcon } from 'assets/images/copy-link.svg';
import { useToastContext } from 'auto-design-common';
import useTranslation from 'hooks/useTranslation';
import styles from './SharePopup.module.scss';

export default function SharePopup({
  onClose,
  shareUrl,
}) {
  const { tGenAIImage } = useTranslation();
  const { toastSuccess } = useToastContext();
  const [copied, setCopied] = useState(false);

  const shareOnFacebook = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toastSuccess('Link copied to clipboard!');
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = shareUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      toastSuccess('Link copied to clipboard!');
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const shareOnTwitter = () => {
    const text = 'Check out this amazing AI-generated image!';
    const url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(text)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  return (
    <Modal
      show
      onHide={onClose}
      backdrop="static"
      className={styles.shareModal}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {tGenAIImage('shareTitle') || 'Share this image'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.shareContainer}>
          <div className={styles.shareText}>
            {tGenAIImage('shareDescription') || 'Share this amazing AI-generated image with your friends and followers!'}
          </div>

          <div className={styles.socialButtons}>
            <button
              type="button"
              className={styles.socialButton}
              onClick={shareOnFacebook}
              title="Share on Facebook"
            >
              <FacebookIcon />
            </button>

            <button
              type="button"
              className={styles.socialButton}
              onClick={shareOnTwitter}
              title="Share on X (Twitter)"
            >
              <TwitterIcon />
            </button>
          </div>

          <div className={styles.copySection}>
            <div className={styles.urlContainer}>
              <input
                type="text"
                value={shareUrl}
                readOnly
                className={styles.urlInput}
              />
            </div>

            <button
              type="button"
              className={`${styles.copyButton} ${copied ? styles.copied : ''}`}
              onClick={copyToClipboard}
            >
              <CopyLinkIcon />
              <span>{copied ? 'Copied!' : 'Copy Link'}</span>
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
